export default __webpack_public_path__ + "static/media/Ballroll_00139.3e573549.png";